import { api } from './services/api';
import { ScheduleItem } from '../types';

// Adapter de compatibilidade para componentes legados
export const apiService = {
    registerInscription: async (data: any): Promise<{ success: boolean; message?: string }> => {
        try {
            const response = await api.post('/inscriptions', data);
            return { 
                success: true, 
                message: response.data.message || 'Inscrição realizada!' 
            };
        } catch (error: any) {
            console.error('Error registering inscription:', error);
            const message = error.response?.data?.error || error.response?.data?.message || 'Falha na comunicação com o servidor.';
            return { 
                success: false, 
                message 
            };
        }
    },

    getEvent: async (idOrSlug: string): Promise<any> => {
        try {
            const response = await api.get(`/events/${idOrSlug}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching event:', error);
            return null;
        }
    },


    getMunicipalityNames: async (): Promise<string[]> => {
        try {
            const response = await api.get('/municipalities/names');
            return response.data;
        } catch (error) {
            console.error('Error fetching municipality names:', error);
            return [];
        }
    },

    getSchedule: async (): Promise<{ morning: ScheduleItem[], afternoon: ScheduleItem[] }> => {
        try {
            const response = await api.get('/schedule');
            return response.data;
        } catch (error) {
            console.error('Error fetching schedule:', error);
            return { morning: [], afternoon: [] };
        }
    },

    login: async (password: string): Promise<boolean> => {
        try {
            // Assumindo que o endpoint de login é /auth/login e espera { password }
            // Ajuste conforme a implementação real do AuthController
            await api.post('/auth/login', { password });
            return true;
        } catch (error) {
            console.error('Login failed:', error);
            return false;
        }
    }
};
